export default __webpack_public_path__ + "static/media/call-center-icon.29ed86ff.svg";